'use strict';

require('../common/trim.js');
var toggleChildFields = require('./toggleChildFields');

module.exports = function expandingFormElements(container) {

	var handleExpansion = function (e) {
		var $this = window.jQuery(this),
			$target = window.jQuery($this.data('target'));

		if ($this.is('a')) {
			e.preventDefault();
			$target.addClass('active');
			$this.closest('.hide-on-expand').hide('fast');
			return false;
		} else if ($this.is('input[type=checkbox]')) {
			var name = $this.attr('name');
			var expand = false;
			window.jQuery('input[name=' + name + ']').each(function () {
				if (window.jQuery(this).data('expand') && window.jQuery(this).is(':checked')) {
					expand = true;
				}
			});

			if (expand) {
				$target.addClass('active');
			} else {
				$target.removeClass('active');
			}
		} else if ($this.is('input[type=radio]')) {
			var checked = $this.is(':checked');

			if (checked) {
				if ($this.data('expand')) {
					$target.addClass('active');
				} else if ($this.data('collapse')) {
					$target.removeClass('active');
				}
			}
		} else if ($this.is('select')) {
			var selectedOption = $this.find('option:selected');
			var expand = selectedOption.data('expand');

			if (expand) {
				$target.addClass('active');
			} else {
				$target.removeClass('active');
			}
		} else if ($this.is('input[type=text]')) {
			if ($this.val().trim().length > 0) {
				$target.addClass('active');
			} else {
				$target.removeClass('active');
			}
		}

		//update the frequent flyer required status depending on current ff-saving-status
		toggleChildFields(container);
	};

	window.jQuery(container).on('click', '.expander', handleExpansion);
	window.jQuery(container).on('keyup change', 'input.expander,select.expander', handleExpansion);

	//initialize starting state of text fields
	window.jQuery('input.expander,select.expander', container).each(function () {
		handleExpansion.apply(this);
	});
};
